import { useRef } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useModal, useToast } from "@/comn/hooks";
import { useRecoilState, useSetRecoilState } from "recoil";
import { loginFormState, authState, storeState } from "../recoil";
import { defaultLoginFormState } from "../recoil/loginFormState";
import { defaultStoreState } from "../recoil/storeState";
import bookmarkState from "../recoil/bookmarkState";
import { _TEST1234 } from "../config/ApiConfig";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    api_acrbt: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/ptl/acrdt`,
    api_ofcr: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/usr/cstm-ofcrs`,
    nodes: [],
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Get a list of Customs Role. !== 세관 역할 목록을 조회한다. ==!
    getCstmRoleList: (data: any) => {
        return api.get(`${BASE.api_ofcr}/roles?`, {
            params: comnUtils.toGetParams(data),
        });
    },
};

const validateUser = async (data: any) => {
    try {
        const { id, pwd, lcm } = data;
        let path = `/api/v1/${_TEST1234.PORTAL_TYPE}/comn/login/valdn`,
            payload: any = {};
        payload.id = String(id).toUpperCase();
        payload.pwd = pwd;

        switch (_TEST1234.SYSTEM_GROUP_ORI) {
            case "tanesw": {
                if (lcm) payload.lgnTp = "LCM";
                if (!lcm) payload.lgnTp = "EXT";
                break;
            }
            case "tanoga":
                payload.lgnTp = "OGA";
                break;
        }

        let vldnUri = _TEST1234.PORTAL_API_ORI;
        //// 로그인 내부 포털로 연계되도록 수정.
        if (_TEST1234.SYSTEM_GROUP_ORI === "tanoga") {
            vldnUri = process.env.REACT_APP_API_OSCI as string;
        }
        console.log("vldnUri ===== > %s", vldnUri);
        // const response = await axios.post(_TEST1234.PORTAL_API_ORI + path, payload, {
        //     headers: { "Accept-Language": Cookies.get("lang")?.toUpperCase() || "EN" },
        // });
        const response = await axios.post(vldnUri + path, payload, {
            headers: { "Accept-Language": Cookies.get("lang")?.toUpperCase() || "EN" },
        });
        return response.data.coUsrYn.content;
    } catch (error) {
        throw error;
    }
};

const getUsrCstmList = async (data: any) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_OSCI}/api/v1/${_TEST1234.PORTAL_TYPE}/comn/login/cstmList`,
            {
                ...data,
                id: String(data.id).toUpperCase(),
            },
            { headers: { "Accept-Language": Cookies.get("lang")?.toUpperCase() || "EN" } },
        );
        return response.data.usrCstmList.content;
    } catch (error) {
        throw error;
    }
};

const getCompanyList = async (data: any) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_OSCI}/api/v1/${_TEST1234.PORTAL_TYPE}/comn/login/coTpList`,
            {
                ...data,
                id: String(data.id).toUpperCase(),
            },
        );
        const content = response.data.coTpList.content;
        return content;
    } catch (error) {
        throw error;
    }
};

const changeCustom = async (data: any) => {
    try {
        const accessToken = _TEST1234.AUTHORIZATION;
        const lang = Cookies.get("lang")?.toUpperCase() || "EN";
        const response = await axios.post(
            `${process.env.REACT_APP_API_OSCI}/api/v1/${_TEST1234.PORTAL_TYPE}/comn/login/chgCstmCd`,
            data,
            { headers: { Authorization: "Bearer " + accessToken, "Accept-Language": lang } },
        );
        const { authorization, refreshauthorization } = response.headers;

        _TEST1234.AUTHORIZATION = authorization.substring(7);
        _TEST1234.REFRESH_AUTHORIZATION = refreshauthorization.substring(7);

        return { ...response.data.userInfo.content };
    } catch (error) {
        console.log(error);
        throw error;
    }
};

const changeCompany = async (data: any) => {
    try {
        const accessToken = _TEST1234.AUTHORIZATION;
        const lang = Cookies.get("lang")?.toUpperCase() || "EN";
        const response = await axios.post(
            `${process.env.REACT_APP_API_OSCI}/api/v1/${_TEST1234.PORTAL_TYPE}/comn/login/chgCoCd`,
            data,
            { headers: { Authorization: "Bearer " + accessToken, "Accept-Language": lang } },
        );
        const { authorization, refreshauthorization } = response.headers;

        // Cookies.set("authorization", authorization.substr(7), { expires: 30 });
        // Cookies.set("refreshauthorization", refreshauthorization.substr(7), { expires: 30 });
        _TEST1234.AUTHORIZATION = authorization.substr(7);
        _TEST1234.REFRESH_AUTHORIZATION = refreshauthorization.substr(7);

        const content = { ...response.data.userInfo.content, chkMsg: { ...response.data.chkMsg } };
        return content;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

const login = async (data: any) => {
    try {
        const {
            id,
            pwd,
            lcm,
            coTin,
            coTpCd,
            coCd,
            cstmCd,
        } = data;

        let base = "",
            path = "",
            payload: any = {};
        payload.id = String(id).toUpperCase();
        payload.pwd = pwd;

        const nodeEnv = process.env.NODE_ENV;
        // TODO OGA 로 변경.
        base = process.env.REACT_APP_API_OSCI || "";
        path = `/api/v1/${_TEST1234.PORTAL_TYPE}/comn/login/oga`;
        payload.coTin = coTin;
        payload.coTpCd = coTpCd;
        payload.coCd = coCd;

        const lang = Cookies.get("lang")?.toUpperCase() || "EN";
        const response = await axios.post(base + path, payload, { headers: { "Accept-Language": lang } });

        //const { data } = await axios.get(url, { headers: { "Accept-Language": lang } });
        const { authorization, refreshauthorization } = response.headers;

        // Cookies.set("authorization", authorization.substr(7), { expires: 30 });
        // Cookies.set("refreshauthorization", refreshauthorization.substr(7), { expires: 30 });
        _TEST1234.AUTHORIZATION = authorization.substr(7);
        _TEST1234.REFRESH_AUTHORIZATION = refreshauthorization.substr(7);

        const content = { ...response.data.userInfo.content, chkMsg: { ...response.data.chkMsg } };
        return content;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const useLogin = () => {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const modal = useModal();
    const setStore = useSetRecoilState(storeState);
    const setBookmark = useSetRecoilState(bookmarkState);
    const [auth, setAuth] = useRecoilState(authState);
    const [loginForm, setLoginForm] = useRecoilState(loginFormState);
    const { id, pwd, lcm, coTin, coTpCd, coCd, cstmCd } =
        loginForm;

    const ref = useRef({ loading: false });

    const reset = () => {
        setLoginForm(defaultLoginFormState);
    };

    const handleSuccess = (data: any) => {
        /** Reset page store (recoil) */
        setStore(defaultStoreState);
        /** Reset login form (recoil) */
        reset();

        /** Set auth (recoil, session storage) */
        setAuth({ ...data, isSignedIn: true, signedAt: new Date(), isInitialized: true });
        window.sessionStorage.setItem("user-info", JSON.stringify(data.userInfo));

        /** Show toast */
        showToast({ content: "Sign In" });

        /** Redirect */
        let ptlPath = "";
        ptlPath = "/osci";

        window.location.href = window.location.origin + ptlPath;
    };

    const handleError = (error: any) => {
        ref.current.loading = false;
        setLoginForm((prev) => ({ ...prev, loading: false }));
        showToast({ content: error.response?.data?.errorMessage?.content || "error", type: "error" });
    };

    /** 개발용 */
    const devLogin = async (props: any) => {
        if (ref.current.loading) return;
        ref.current.loading = true;
        const { id, pwd, coTin, coTpCd, coCd } = props;

        let coUsrYn;
        try {
            coUsrYn = await validateUser({ id: String(id).toUpperCase(), pwd, lcm });
        } catch (error) {
            handleError(error);
            return;
        }

        if (coUsrYn !== "Y") {
            try {
                let systemGroup = _TEST1234.SYSTEM_GROUP_ORI;
                let type = "";
                type === "OGA";
                const userInfo = await login({ id, pwd, lcm });
                handleSuccess({ userInfo, type, coUsrYn });
            } catch (error) {
                handleError(error);
            }
            return;
        } else {
            try {
                const userInfo = await login({ id, pwd, coTin, coTpCd, coCd });
                handleSuccess({ userInfo, type: "EXT", coUsrYn: "Y" });
            } catch (error) {
                handleError(error);
            }
            return;
        }
    };

    const handleSubmitLogin = async (event: any) => {
        event.preventDefault();

        if (ref.current.loading) return;
        ref.current.loading = true;
        setLoginForm((prev) => ({ ...prev, loading: true }));

        //  1.  Validate user information & check user type
        let coUsrYn;

        try {
            coUsrYn = await validateUser({ id, pwd, lcm });
        } catch (error) {
            handleError(error);
            return;
        }

        let systemGroup = _TEST1234.SYSTEM_GROUP_ORI;
        console.log(systemGroup);
        let type = "OGA";
        // 2.   CO user
        if (coUsrYn === "Y") {
            let coTpList: any;
            try {
                coTpList = await getCompanyList({ id, lgnTp: type });
            } catch (error) {
                handleError(error);
                return;
            }

            if (coTpList.length === 0) {
                try {
                    const userInfo = await login({
                        id,
                        pwd,
                        coTin,
                    });

                    if (userInfo.chkMsg?.content) {
                        reset();
                        modal.openModal({
                            id: "chkMsg",
                            content: userInfo.chkMsg.content,
                            onCancel: () => {
                                handleSuccess({ userInfo, type: type, coUsrYn: "Y" });
                            },
                        });
                    } else {
                        handleSuccess({ userInfo, type: type, coUsrYn: "Y" });
                    }
                } catch (error) {
                    handleError(error);
                }
                return;
            }

            //  3.  One company
            if (coTpList.length === 1) {
                try {
                    const { coTin, coDclaTp, coDclaCd } = coTpList[0];
                    const userInfo = await login({
                        id,
                        pwd,
                        coTin,
                        coTpCd: coDclaTp,
                        coCd: coDclaCd,
                    });

                    if (userInfo.chkMsg?.content) {
                        reset();
                        modal.openModal({
                            id: "chkMsg",
                            content: userInfo.chkMsg.content,
                            onCancel: () => {
                                handleSuccess({ userInfo, type: type, coUsrYn: "Y" });
                            },
                        });
                    } else {
                        handleSuccess({ userInfo, type: type, coUsrYn: "Y" });
                    }
                } catch (error) {
                    handleError(error);
                }
                return;
            }

            //  3.  Change form
            ref.current.loading = false;
            setLoginForm((prev) => ({ ...prev, type: "company", coTpList, loading: false }));
            return;
        }

        //  2.  Not CO user
        if (coUsrYn !== "Y") {
            try {
                const userInfo = await login({
                    id,
                    pwd,
                    lcm,
                });
                handleSuccess({ userInfo, type, coUsrYn });
            } catch (error) {
                handleError(error);
            }
            return;
        }
    };

    const handleSubmitCustom = async (event: any) => {
        event.preventDefault();

        // Check loading status
        if (ref.current.loading) return;
        ref.current.loading = true;
        setLoginForm((prev) => ({ ...prev, loading: true }));

        try {
            const authorization = _TEST1234.AUTHORIZATION;
            if (authorization) {
                const userInfo = await changeCustom({ cstmCd });
                handleSuccess({ userInfo, type: userInfo.lgnTp, coUsrYn: userInfo.coUsrYn });
            } else {
                const userInfo = await login({
                    id,
                    pwd,
                    cstmCd,
                });
                handleSuccess({ userInfo, type: userInfo.lgnTp, coUsrYn: userInfo.coUsrYn });
            }
        } catch (error: any) {
            handleError(error);
        }
    };

    const handleSubmitCompany = async (event: any) => {
        event.preventDefault();

        // Check loading status
        if (ref.current.loading) return;
        ref.current.loading = true;
        setLoginForm((prev) => ({ ...prev, loading: true }));

        const authorization = _TEST1234.AUTHORIZATION;

        if (authorization) {
            try {
                const userInfo = await changeCompany({ coTin, coTpCd, coCd, lgnTp: auth.userInfo.lgnTp });

                if (userInfo.chkMsg?.content) {
                    reset();
                    modal.openModal({
                        id: "chkMsg",
                        content: userInfo.chkMsg.content,
                        onCancel: () => {
                            handleSuccess({ userInfo, type: userInfo.lgnTp, coUsrYn: userInfo.coUsrYn });
                        },
                    });
                } else {
                    handleSuccess({ userInfo, type: userInfo.lgnTp, coUsrYn: userInfo.coUsrYn });
                }

                //handleSuccess({ userInfo, type: userInfo.lgnTp, coUsrYn: userInfo.coUsrYn });
            } catch (error: any) {
                handleError(error);
            }
        }

        if (!authorization) {
            try {
                const userInfo = await login({
                    id,
                    pwd,
                    coTin,
                    coTpCd,
                    coCd,
                });

                if (userInfo.chkMsg?.content) {
                    reset();
                    modal.openModal({
                        id: "chkMsg",
                        content: userInfo.chkMsg.content,
                        onCancel: () => {
                            handleSuccess({ userInfo, type: userInfo.lgnTp, coUsrYn: userInfo.coUsrYn });
                        },
                    });
                } else {
                    handleSuccess({ userInfo, type: userInfo.lgnTp, coUsrYn: userInfo.coUsrYn });
                }
            } catch (error: any) {
                handleError(error);
            }
        }
    };

    const handleLogin = () => {
        navigate("/login");
    };

    const handleCustom = async () => {
        // Check loading status
        if (ref.current.loading) return;
        ref.current.loading = true;
        setLoginForm((prev) => ({ ...prev, loading: true }));

        try {
            const usrCstmList = await getUsrCstmList({ id: auth.userInfo.usrId });
            setLoginForm((prev) => ({ ...prev, open: true, type: "custom", usrCstmList, loading: false }));
            ref.current.loading = false;
        } catch (error) {
            handleError(error);
        }
    };

    const handleCompany = async () => {
        // Check loading status
        if (ref.current.loading) return;
        ref.current.loading = true;
        setLoginForm((prev) => ({ ...prev, loading: true }));

        try {
            const coTpList = await getCompanyList({ id: auth.userInfo.usrId, lgnTp: auth.userInfo.lgnTp });
            setLoginForm((prev) => ({ ...prev, open: true, type: "company", coTpList, loading: false }));
            ref.current.loading = false;
        } catch (error) {
            handleError(error);
        }
    };

    const handleRegist = () => {
        window.location.href = window.location.origin + "/osci/usr/info/osci0103001s?menuId=menu_osci0102";
    };

    const logout = () => {
        const ptl = _TEST1234.PORTAL_API_ENV;
        const authorization = _TEST1234.AUTHORIZATION;
        const refreshauthorization = _TEST1234.REFRESH_AUTHORIZATION;
        try {
            axios.delete(ptl + "/api/v1/ptl/comn/comn/logout", {
                headers: {
                    Authorization: "Bearer " + authorization,
                    Refreshauthorization: "Bearer " + refreshauthorization,
                },
            });
        } catch (error) {
            console.log(error);
        }

        window.sessionStorage.removeItem("user-info");
        window.sessionStorage.removeItem("menu-config");
        window.sessionStorage.removeItem("menu-signed");
        window.sessionStorage.removeItem("menu-nonSigned");
        window.sessionStorage.removeItem("survey-ppupCheck");
        Cookies.remove("authorization");
        Cookies.remove("refreshauthorization");
        Cookies.remove(`authorization_${_TEST1234.SYSTEM_GROUP_ORI}`);
        Cookies.remove(`refreshauthorization_${_TEST1234.SYSTEM_GROUP_ORI}`);

        setBookmark([]);
        setStore(defaultStoreState);
        setAuth({
            userInfo: {},
            isSignedIn: false,
            signedAt: null,
            isInitialized: true,
        });
        showToast({ content: "Sign Out" });
        navigate("/login");
    };

    return {
        loginForm,
        setLoginForm,
        handleSubmitLogin,
        handleSubmitCustom,
        handleSubmitCompany,
        handleLogin,
        handleCustom,
        handleCompany,
        handleRegist,
        logout,
        reset,
        devLogin,
    };
};

export const SF_CSTM_OFCR_INFO_FORM: TFormSchema = {
    id: "form_cstmOfcrInfo",
    schema: {
        cstmSctnOrgzCd: { type: "code", area: "orgzSub", popupSize: "md", labelSize: 0 },
        cstmSctnOrgzCdNm: { type: "text", label: "L_CSTM_SCTN" },

        cstmOfceCd: { type: "select", area: "cstmCd", labelSize: 0 },
        cstmOfceCdNm: { type: "text", label: "L_CSTM_OFCE" },

        cstmUnitOrgzCdNm: { type: "text", label: "L_CSTM_UNIT" },
        cstmUnitOrgzCd: { type: "select", labelSize: 0 },

        roleId: { type: "select", label: "L_ROLE_NM" },
        roleNm: { type: "text", label: "L_ROLE_NM" },
    },
};
